import { ChangeDetectionStrategy, Component, input, OnDestroy, OnInit, signal } from '@angular/core';

const lineCount = 11;

@Component({
  selector: 'app-audio-volume-indicator',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './audio-volume-indicator.component.html',
  styleUrl: './audio-volume-indicator.component.scss',
})
export class AudioVolumeIndicatorComponent implements OnInit, OnDestroy {
  audioVolume = signal<number[]>(new Array(lineCount).fill(0));
  maxVolume = signal(0);
  audioPlayer = input.required<HTMLAudioElement>();
  destroyed = false;

  ngOnInit(): void {
    const audioCtx = new (window.AudioContext || window['webkitAudioContext'])();
    const analyser = audioCtx.createAnalyser();
    analyser.fftSize = 32;

    const source = audioCtx.createMediaElementSource(this.audioPlayer());
    source.connect(analyser);
    analyser.connect(audioCtx.destination);

    const dataArray = new Uint8Array(analyser.frequencyBinCount);

    this.audioPlayer().addEventListener('play', () => {
      if (audioCtx.state === 'suspended') {
        audioCtx.resume();
      }
      this.updateVolume(analyser, dataArray);
    });

    this.audioPlayer().addEventListener('pause', () => {
      audioCtx.suspend();
      this.audioVolume.set(new Array(lineCount).fill(0));
      this.maxVolume.set(0);
    });
    this.audioPlayer().addEventListener('ended', () => {
      audioCtx.suspend();
      this.audioVolume.set(new Array(lineCount).fill(0));
      this.maxVolume.set(0);
    });
  }

  private updateVolume(analyser: AnalyserNode, dataArray: Uint8Array) {
    if (this.destroyed) return;
    if (this.audioPlayer().paused) return;

    requestAnimationFrame(() => this.updateVolume(analyser, dataArray));

    analyser.getByteFrequencyData(dataArray);

    const array = Array.from(dataArray);
    const max = Math.max(...array);

    const audioVolume: number[] = [];

    const res = array.length / lineCount;
    const length = Math.floor(lineCount / 2);
    for (let i = 0; i < length; i++) {
      audioVolume[i] = array[Math.floor(i * res)];
    }

    const mirroredVolume = [...audioVolume.slice().reverse(), array[0], ...audioVolume];

    this.audioVolume.set(mirroredVolume);
    if (max > this.maxVolume()) {
      this.maxVolume.set(max);
    }
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }
}
